"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontLineHeightLoose = exports.fontLineHeightNormal = exports.fontLineHeightSnug = exports.fontLineHeightTight = exports.fontLineHeightTighter = void 0;
exports.fontLineHeightTighter = '125%';
exports.fontLineHeightTight = '133%';
exports.fontLineHeightSnug = '145%';
exports.fontLineHeightNormal = '150%';
exports.fontLineHeightLoose = '160%';